export const getBookingCountLabel = (totalNumber: number = 0) => {
  return `${totalNumber} booking${totalNumber === 1 ? '' : 's'} found`;
};
